module.exports = __webpack_public_path__ + "img/presentation-icon.b9becbd8.png";